const escort = {
  dashboard: {
    welcome: "Welcome",
    dashboard_description: "Manage your profile, view statistics, and access quick actions.",
    profile_views: "Profile Views",
    new_messages: "New Messages",
    pending_bookings: "Pending Bookings",
    weekly_income: "Weekly Income",
    profile_completeness: "Profile Completeness",
    complete_profile: "Complete Profile",
    add_photos: "Add Photos",
    verify_identity: "Verify Identity",
    setup_rates: "Setup Rates",
    manage_services: "Manage Services",
    promote_profile: "Promote Profile",
    quick_actions: "Quick Actions",
    edit_profile: "Edit Profile",
    view_profile: "View Profile",
    manage_media: "Manage Media",
    view_bookings: "View Bookings",
    earnings_report: "Earnings Report",
    security_center: "Security Center",
    logout: "Logout",
    profile_tips: "Profile Tips",
    tip_1: "Use high-quality photos to attract more clients.",
    tip_2: "Keep your profile updated with your latest services and rates.",
    tip_3: "Respond to messages promptly to increase booking chances.",
    tip_4: "Get verified to build trust with potential clients.",
    all_rights_reserved: "All Rights Reserved",
    terms_of_service: "Terms of Service",
    privacy_policy: "Privacy Policy",
    cookie_policy: "Cookie Policy",
    accessibility: "Accessibility",
    contact_us: "Contact Us",
    about_us: "About Us",
    faq: "FAQ",
    sitemap: "Sitemap",
    blog: "Blog",
    social_media: "Social Media",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    pinterest: "Pinterest",
    newsletter: "Newsletter",
    subscribe: "Subscribe",
    copyright: "Copyright",
  },
  profile: {
    title: "Escort Profile",
    manage_profile: "Manage Profile",
    profile_description: "Edit your information, services, rates, and other details.",
    basic_info: "Basic Info",
    services: "Services",
    rates: "Rates",
    visibility: "Visibility",
    ai: {
      tab_title: "AI Assistant"
    },
    error_loading: "Error Loading Profile",
    try_again_later: "Please try again later",
    unable_to_load_or_create: "Unable to load or create profile at the moment.",
    create_profile_title: "Create Your Escort Profile",
    create_profile_desc: "Fill in the information below to get started.",
    personal_details: "Personal Details",
    start_by_filling_info: "Start by filling in your personal information.",
    edit_profile: "Edit Profile",
    view_profile: "View Profile",
    profile_details: "Profile Details",
    personal_info: "Personal Information",
    name: "Name",
    display_name: "Display Name",
    display_name_placeholder: "Your public display name",
    age: "Age",
    gender: "Gender",
    select_gender: "Select your gender",
    location: "Location",
    city: "City",
    city_placeholder: "Your city",
    country: "Country",
    country_placeholder: "Your country",
    availability: "Availability",
    languages: "Languages",
    description: "Description",
    bio_short: "Short Bio",
    bio_short_placeholder: "Catchy tagline (max 150 chars)",
    bio_full: "Full Bio",
    bio_full_placeholder: "Describe yourself in more detail",
    physical_attributes: "Physical Attributes",
    height_cm: "Height (cm)",
    weight_kg: "Weight (kg)",
    hair_color: "Hair Color",
    hair_color_placeholder: "e.g., Brown, Blonde, Red...",
    eye_color: "Eye Color",
    eye_color_placeholder: "e.g., Blue, Green, Brown...",
    ethnicity: "Ethnicity",
    select_ethnicity: "Select your ethnicity",
    nationality: "Nationality",
    nationality_placeholder: "Your nationality",
    body_type: "Body Type",
    select_body_type: "Select your body type",
    sexual_orientation: "Sexual Orientation",
    select_orientation: "Select your orientation",
    create_profile_button: "Create Profile",
    verify_identity: "Verify Identity",
    identity_verified: "Identity Verified",
    not_verified: "Not Verified",
    verify_now: "Verify Now",
    profile_views: "Profile Views",
    last_active: "Last Active",
    member_since: "Member Since",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    upload_photo: "Upload Photo",
    manage_photos: "Manage Photos",
    photos_description: "Upload high-quality photos to attract more clients.",
    no_photos: "No photos yet. Upload your first photo now!",
    upload_first_photo: "Upload First Photo",
    profile_photo: "Profile Photo",
    main: "Main",
    private: "Private",
    delete_photo: "Delete Photo",
    set_main: "Set as Main",
    photo_visibility_updated: "Photo visibility updated",
    photo_now_public: "Photo is now public",
    photo_now_private: "Photo is now private",
    private_visibility: "Private Visibility",
    public_visibility: "Public Visibility",
    error_loading_photos: "Error loading photos",
    photo_uploaded: "Photo uploaded",
    photo_upload_success: "Photo uploaded successfully",
    upload_error: "Upload error",
    photo_deleted: "Photo deleted",
    photo_delete_success: "Photo deleted successfully",
    delete_error: "Delete error",
    main_photo_updated: "Main photo updated",
    main_photo_update_success: "Main photo updated successfully",
    update_error: "Update error",
    subscription_required: "Subscription Required",
    subscription_unlock: "Subscribe to unlock private gallery",
    storage_unavailable: "Storage Unavailable",
    storage_unavailable_message: "The storage service is currently unavailable. You won't be able to upload images at this time. Please try again later or contact support if this issue persists.",
  },
  calendar: {
    title: "Calendar & Bookings",
    description: "Manage your bookings and availability.",
    calendar_view: "Calendar View",
    availability_settings: "Availability Settings",
    no_bookings_for_day: "No bookings for this day.",
    upcoming_bookings: "Upcoming Bookings",
    error_loading_bookings: "Error loading bookings",
    try_again_later: "Please try again later",
    no_upcoming_bookings: "No upcoming bookings.",
    bookings_appear_here: "Your upcoming bookings will appear here.",
    booking_updated: "Booking Updated",
    booking_status_changed: "Booking status changed to {{status}}.",
    pending: "Pending",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    completed: "Completed",
    date: "Date",
    time: "Time",
    client: "Client",
    duration: "Duration",
    price: "Price",
    status: "Status",
    actions: "Actions",
    unknown_client: "Unknown Client",
    confirm: "Confirm",
    cancel: "Cancel",
    mark_completed: "Mark as Completed",
    error_updating_booking: "Error updating booking"
  },
  finances: {
    title: "Finances",
    description: "Track your earnings, manage transactions and withdrawals.",
    total_earned: "Total Earned",
    pending_payments: "Pending Payments",
    transactions: "Transactions",
    invoices: "Invoices",
    withdrawal: "Withdrawal",
    revenue_chart: "Revenue Chart",
    period: "Period",
    this_week: "This Week",
    this_month: "This Month",
    this_year: "This Year",
    custom_range: "Custom Range",
    request_withdrawal: "Request Withdrawal",
    create_invoice: "Create Invoice",
    generate_report: "Generate Report",
    add_payment_method: "Add Payment Method",
    payment_received: "Payment Received",
    payment_sent: "Payment Sent"
  },
  media: {
    title: "Media Manager",
    description: "Manage your photos, videos, and premium content.",
    public_photos: "Public Photos",
    videos: "Videos",
    premium_content: "Premium Content",
    upload: "Upload",
    no_media: "No media yet. Upload your first item now!",
    drag_drop: "Drag and drop files here or click to upload",
    upload_photo: "Upload Photo",
    upload_video: "Upload Video",
    upload_premium: "Upload Premium Content",
    set_as_private: "Make private",
    set_as_public: "Make public",
    delete_media: "Delete",
    description_label: "Description",
    sell_content: "Sell this content",
    price: "Price",
    supported_formats: "Supported formats: JPEG, PNG, MP4",
    file_size_limit: "File size limit: 10MB",
    media_deleted: "Media deleted successfully",
    set_as_main: "Set as Main",
    error_loading: "Error loading media",
  },
  security: {
    title: "Security Center",
    description: "Manage your account security settings.",
    change_password: "Change Password",
    two_factor_authentication: "Two-Factor Authentication",
    enable_2fa: "Enable Two-Factor Authentication",
    disable_2fa: "Disable Two-Factor Authentication",
    
    "2fa_enabled": "Two-Factor Authentication Enabled",
    "2fa_disabled": "Two-Factor Authentication Disabled",
    
    error_enabling_2fa: "Error enabling Two-Factor Authentication",
    error_disabling_2fa: "Error disabling Two-Factor Authentication",
  },
  filters: {
    gender: "Gender",
    age: "Age",
    location: "Location",
    availability: "Availability",
    languages: "Languages",
    services: "Services",
    rates: "Rates",
    photos: "Photos",
    videos: "Videos",
    reviews: "Reviews",
    online_now: "Online Now",
    verified_only: "Verified Only",
    apply_filters: "Apply Filters",
    reset_filters: "Reset Filters",
  },
  rates: {
    title: "Rates",
    hourly: "Hourly Rate",
    daily: "Daily Rate",
    weekly: "Weekly Rate",
    monthly: "Monthly Rate",
    additional_services: "Additional Services",
    add_service: "Add Service",
    service_name: "Service Name",
    service_description: "Service Description",
    service_rate: "Service Rate",
    save_service: "Save Service",
    delete_service: "Delete Service",
    '30min': 'For 30 minutes',
    '1hour': 'For 1 hour',
  },
};

export default escort;
